/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { compose } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import { APPOINTMENT_STATUS } from '../constants';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserViewRegister } from '../../../common/helpers/users';
import withCheckBarberIsClockedIn from '../../timeTracker/hoc/withCheckBarberIsClockedIn';

const SelectStatus = (props) => {
  const {
    noShow,
    paidInShop,
    permissions,
    toggleNoShow,
    toggleArrived,
    selectedStatus,
    togglePaidInShop,
    shouldRenderPaidInShop,
    barberReady,
    toggleBarberReady,
    disabled,
  } = props;

  const arrivedClass = classNames('c-tags__item u-1/5', {
    'is-active': !noShow && selectedStatus === APPOINTMENT_STATUS.arrived,
    'is-disabled': disabled,
  });
  const paidInShopClass = classNames('c-tags__item u-1/4', {
    'is-active': !noShow && paidInShop,
    'is-disabled': disabled,
  });
  const noShowClass = classNames('c-tags__item u-1/4', { 'is-error': noShow, 'is-disabled': disabled });
  const barberReadyClass = classNames('c-tags__item u-1/5', { 'is-active': barberReady, 'is-disabled': disabled });

  return (
    <div className="u-mt-">
      <div className="c-label-new u-align-middle">{t('appointment:form.select_status.title')}</div>
      <div>
        <button type="button" className={arrivedClass} onClick={toggleArrived} disabled={disabled}>
          {t('appointment:form.select_status.arrived')}
        </button>
        <button type="button" className={barberReadyClass} onClick={toggleBarberReady} disabled={disabled}>
          {t('appointment:form.select_status.ready')}
        </button>
        <button
          type="button"
          className={paidInShopClass}
          onClick={togglePaidInShop}
          display-if={shouldRenderPaidInShop && canUserViewRegister(permissions)}
          disabled={disabled}
        >
          {t('appointment:form.select_status.paid_in_shop')}
        </button>
        <button type="button" className={noShowClass} onClick={toggleNoShow} disabled={disabled}>
          {t('appointment:form.select_status.no_show')}
        </button>
      </div>
    </div>
  );
};

SelectStatus.propTypes = {
  selectedStatus: PropTypes.number.isRequired,
  noShow: PropTypes.bool.isRequired,
  paidInShop: PropTypes.bool.isRequired,
  toggleArrived: PropTypes.func.isRequired,
  toggleNoShow: PropTypes.func.isRequired,
  togglePaidInShop: PropTypes.func.isRequired,
  shouldRenderPaidInShop: PropTypes.bool.isRequired,
  barberReady: PropTypes.bool.isRequired,
  toggleBarberReady: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  permissions: PropTypes.shape({}),
};

SelectStatus.defaultProps = {
  disabled: false,
  permissions: {},
};

export default compose(
  withPermissions,
  withCheckBarberIsClockedIn('togglePaidInShop', (props) => [props.barberId])
)(SelectStatus);
